import React from 'react'

function School_port_TS({
  mpesa,
  school_name,
  location,
  adress,
  email,
  contact,
  contacteename,
  intakedirecto,
  paymentg
}) {

  const accept = () =>
  {
   // mpesa(true)
    alert('COGRATULATIONS!! All good!!')
  }
  return (
    <div className='inner_TC_MAIN'>

    <div>
        <h1 className='h_TC'>Terms and Conditions</h1>
    <div className='t_ctext'>
    By accessing and using the School Protal Portal, you agree to be bound by these Terms and Conditions. 
      You are responsible for maintaining the confidentiality of your account 1  credentials and using the 
      Portal only for legitimate educational purposes. The school reserves the right to suspend or terminate 
      your account for unauthorized access or misuse. Your personal information will be handled in accordance 
      with applicable data protection laws. The school may modify these Terms and Conditions at any time, and 
      any changes will be effective immediately upon posting on the Portal. 
      For any questions or concerns, please contact Hostel Adventures at 0715 656 836.
    </div>
    <div className='T_C_Buttons'>
        <button className='acc_BTN' onClick={accept}>I accept</button>
        <button className='dec_BTN'>I decline</button>
    </div>
    </div>
    </div>
  )
}

export default School_port_TS